import dayjs from 'dayjs';

import { IDateToType, IUserSettingsFilters } from '../types/user.type';

export class FiltersHelper {
  /**
   * Get date to
   *
   * @param filters
   */
  static getDateTo(filters?: IUserSettingsFilters | null) {
    return !filters?.dateToType || filters?.dateToType === IDateToType.today
      ? dayjs()
      : dayjs().add(1, 'day');
  }
}
